import PropTypes from "prop-types"
import { Table } from "@mui/material"
import ContributorsTableContent from "components/contributors-table-content"
import { sortData } from "helpers/contributorsSort"
import ContributorsTableGroupHead from "components/contributors-table-group-head"
import { THRESHOLD_PARAMS } from "helpers/threshold"

function ContributorsTotal({ disabled, data, show, openFactorProfile, factorCategoryName, factorTable, groupSort, groupOrder, thresholdParams }) {
  return <Table className="composite-factor-sensitivity-contributors">
    <ContributorsTableGroupHead {...{
      tooltipText: "1 STD Factor Impact (%)",
      displayTypeName: factorCategoryName,
      groupOrder,
      groupSort,
      label: "1 STD Factor Impact (%)",
    }}
    />
    <ContributorsTableContent {...{
      factors: true,
      noPercent: true,
      allFactors: true,
      openFactorProfile,
      data: sortData(data, groupOrder),
      show,
      factorTable,
      disabled,
      thresholdParams,
    }}
    />
  </Table>
}

ContributorsTotal.propTypes = {
  disabled: PropTypes.bool,
  data: PropTypes.array.isRequired,
  viewType: PropTypes.string.isRequired,
  factorCategoryName: PropTypes.string.isRequired,
  openFactorProfile: PropTypes.func,
  show: PropTypes.func.isRequired,
  factorTable: PropTypes.bool.isRequired,
  groupSort: PropTypes.func.isRequired,
  groupOrder: PropTypes.object.isRequired,
  thresholdParams: THRESHOLD_PARAMS,
}

export default ContributorsTotal
